// Constants for table cell formatters.
// @flow
export const FORMATTER_DATA_TYPES = {
    INTEGER: 'integer',
    FLOAT: 'float',
    DATETIME: 'date_time',
    STRING: 'string',
    PERCENT: 'percent',
    TEAM_LOGO: 'team_logo',
    CURRENCY: 'currency',
    BOOLEAN: 'boolean',
    ATTRIB_ICON: 'attrib_icon',
    ICON: 'icon',
    ICONS: 'icon_array'
};

export const ALIGNMENT_CSS_CLASS = {
    CENTER: 'center',
    LEFT: 'left',
    RIGHT: 'right'
};

export const CUSTOM_SORT_PERCENTAGE_COLUMN = (
    a: string,
    b: string,
    order: string
) => {
    const aWithoutPercentSign = a.substring(0, a.length - 1);
    const bWithoutPercentSign = b.substring(0, b.length - 1);

    const intA = parseInt(aWithoutPercentSign, 10);
    const intB = parseInt(bWithoutPercentSign, 10);

    if (order === 'asc') {
        return intA - intB;
    }
    return intB - intA;
};



// WEBPACK FOOTER //
// ./src/view/common/table/formatters/constants.js